import React, { useState } from 'react';
import WeeklyPlanner from './WeeklyPlanner';
import MonthlyPlanner from './MonthlyPlanner';
import PlanWalkthroughModal from './PlanWalkthroughModal';
import { getTranslation } from '../utils/translations';

interface PlanScreenProps {
    weeklyProps: Omit<React.ComponentProps<typeof WeeklyPlanner>, 'onInfoClick'>;
    monthlyProps: Omit<React.ComponentProps<typeof MonthlyPlanner>, 'onGoToWeek' | 'onInfoClick'> & {
        onGoToWeek: (offset: number) => void;
    };
    language?: 'en' | 'he';
}

const PlanScreen: React.FC<PlanScreenProps> = ({ weeklyProps, monthlyProps, language }) => {
    const [viewMode, setViewMode] = useState<'week' | 'month'>('week');
    const [isWalkthroughOpen, setIsWalkthroughOpen] = useState(false);
    const t = (key: string) => getTranslation(language, key);

    const handleGoToWeek = (offset: number) => {
        monthlyProps.onGoToWeek(offset);
        setViewMode('week');
    };

    return (
        <div className="flex flex-col h-full relative overflow-hidden bg-slate-100 dark:bg-slate-950 font-rubik">
            {/* Planners render their own unified PlannerHeader */}
            {viewMode === 'week' ? (
                <WeeklyPlanner 
                    {...weeklyProps} 
                    viewMode={viewMode} 
                    setViewMode={setViewMode} 
                    onInfoClick={() => setIsWalkthroughOpen(true)} 
                />
            ) : (
                <MonthlyPlanner 
                    {...monthlyProps} 
                    onGoToWeek={handleGoToWeek} 
                    viewMode={viewMode} 
                    setViewMode={setViewMode} 
                    onInfoClick={() => setIsWalkthroughOpen(true)} 
                />
            )}

            <PlanWalkthroughModal
                isOpen={isWalkthroughOpen}
                onClose={() => setIsWalkthroughOpen(false)}
                language={language}
            />
        </div>
    );
};

export default PlanScreen;
